
import {map} from 'rxjs/operators';
import { Component, OnInit} from '@angular/core';
import { KeyValue } from '../key-value';
import { ActivatedRoute, Router } from '@angular/router';
import {AuthorizationService} from '../authorization.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'report-viewer',
  templateUrl: 'report-viewer.component.html',
  styleUrls: ['./report-viewer.component.css']
})

export class ReportViewerComponent {

  sub: any;
  comm: any;
  report: any;
  team: any;
  qtr: any;
  report_data = '';
  report_type = '';
  svg_graph1='';
  svg_graph2='';
  svg_graph3='';
  svg_graph4='';
  date1='';
  date2='';
  community='';
  banks = [];
  ins_reports = [];
  com_reports = [];
  communities = [];
  teams = [];
  index: any;
  t_index: any;
  q_index: any;
  start: any;
  instr: any;
  file_type = [];
  c_reports = [];
  r_val: any;
  b_r = [];
  stud: any;
  what_if='';
  i_teams = [];
  token: any;
  foooter = '';
  bin_file=false;

  constructor(private KeyValueService: KeyValue, private route: ActivatedRoute,
              public authService: AuthorizationService) {
    this.sub = this.route.queryParams.subscribe(params => {
      this.comm = params['c'] || '';
      this.report = params['r'] || '';
      this.team = params['t'] || '';
      this.qtr = params['q'] || '';
      this.start = params['start'] || '';
      this.instr = params['instr'] || '';
      this.q_index = params['q_index'] || '';
      this.stud = params['s'] || '';
      this.what_if = params['what_if'] || '';
      this.token = params['token'] || 'undefined';
      this.bin_file = false;
      console.log(this.stud);
    });
  }

  ngOnInit() {
    if(navigator.userAgent.indexOf("Edge") > -1 || navigator.userAgent.indexOf("Trident/7.0") > -1) {
      if (this.token !== localStorage.getItem('accessToken') && this.token !== 'undefined') {
        localStorage.setItem('accessToken', this.token);
        setTimeout(function() {
          window.location.reload();
        }, 1000);
      }
    }
    console.log(this.comm+ ' ' +this.team+ ' '+this.report+' '+this.qtr)
    this.authService.get('/v1/reports/sim_report' + this.reportUrlString()).pipe(
      map(res => res)).subscribe(
      data => {
        this.foooter = data.footer
        this.report_data = data.report
        this.report_type = data.type
        this.svg_graph1 = data.svg_graph1
        this.svg_graph2 = data.svg_graph2
        this.svg_graph3 = data.svg_graph3
        this.svg_graph4 = data.svg_graph4
        this.date1 = data.date1
        this.date2 = data.date2
        this.community = data.community
        this.file_type = ['pdf','decision', 'community', 'excel', 'instructor', 'decisions', 'breports', 'instructor_'+this.comm ]
        if(this.file_type.includes(this.report)){
          this.bin_file=true
          window.location.href = environment.base_url+'/v1/reports/binary_report?type='+this.report_type+'&fkey='+this.report_data;
          // setTimeout(()=>{window.close()},100)          
        }
        if(this.what_if == "true" && data.whatif_reports){
          this.constructString(data);
        } else {
          this.constructString(JSON.parse(localStorage.getItem('r_data')));
        }
      },
      error => {
        console.log('in... signin success' + error)
      }
      )
  }

  constructString(data){
    //    this.teams = data.report_nav.teams[0]
    if(this.what_if == "true"){
      console.log('bank1');
      this.banks = data.whatif_reports.split(",");
    }else{
      this.teams = [].concat.apply([],data.report_nav.teams);
      this.i_teams = data.report_nav.teams;    
      console.log('this.what_if ..'+this.what_if + (this.what_if==''));
      if(this.start === 'undefined'){
        console.log('bank2');      
        this.banks = data.report_nav.b_reports;
        this.index=this.banks.indexOf(this.report)
      } else if (this.instr === '') {
        console.log('bank3');      
        this.banks = data.report_nav.reports[this.q_index].bank
      } else{
        console.log('bank4');      
        this.ins_reports = data.report_nav.reports[this.q_index].ins
        this.communities = data.report_nav.communities
        this.set_report()
      }
    }
    this.t_index=this.teams.indexOf(this.team)
    this.index=this.banks.indexOf(this.report)
  }

  set_report() {
    this.com_reports =['C91-Bank Balance Sheets', 'C92-Income Statements', 'C93-Community Loan and Deposit Markets',
    'C94-Community Bank Capital Activity', 'C95-Economic Charts', 'C96-Economic Reporter', 'I98-Risk and Stock Price Analysis']
    for (let c = 0; c < this.communities.length; c++) {
      this.c_reports = [];
      for (let ins of this.ins_reports){
        for (let i = 0; i < (this.i_teams[c].length); i++) {
          if (!this.com_reports.includes(ins)) {
            this.banks.push(this.communities[c] + '-' + ins +  '-' + (i + 1));
          }else if (i === 0 && this.com_reports.includes(ins)) {
            this.c_reports.push(this.communities[c] + '-' + ins);
          }
        }
      }
      this.banks.push(...this.c_reports);
    }
  }

  navBarChange(val, key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.report = val;
      }else {
        this.comm = val.split(' ')[1][0];
        this.team = val;
      }
    }else {
      this.instrReportSetUp(val);
    }
    window.location.href = window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  instrReportSetUp(val) {
    this.r_val = val.split('-');
    this.report = val;
    this.comm = this.r_val[0];
    this.team = 'Team' + ' ' + this.r_val[0] + (this.r_val[3] || this.i_teams[this.communities.indexOf(this.comm)].length);
  }

  navBarNext(key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.index = this.banks.indexOf(this.report) + 1;
        this.report = this.banks[this.index];
      }else {
        this.t_index = this.teams.indexOf(this.team) + 1;
        this.team = this.teams[this.t_index];
        this.comm = this.team.split(' ')[1][0];
      }
    }else {
      this.instrReportSetUp(this.banks[this.banks.indexOf(this.report) + 1]);
    }
    window.location.href = window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  navBarPrev(key) {
    if (this.instr !== 'undefined') {
      if (key.split('_')[0] === 'report') {
        this.index = this.banks.indexOf(this.report) - 1;
        this.report = this.banks[this.index];
      }else {
        this.t_index = this.teams.indexOf(this.team) - 1;
        this.team = this.teams[this.t_index];
        this.comm = this.team.split(' ')[1][0];
      }
    }else {
      this.instrReportSetUp(this.banks[this.banks.indexOf(this.report) - 1]);
    }
    window.location.href = window.location.origin + '/report/viewer' + this.reportUrlString();
  }

  navBarClose(){
    window.close()
  }

  reportUrlString(): string {
    return '?c='+this.comm+'&t='+this.team+'&r='+this.report+'&q='+this.qtr+'&start='+this.start+'&instr='+this.instr+'&q_index='+this.q_index+'&s='+this.stud+'&what_if='+this.what_if+'&token='+this.token
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
